export default __webpack_public_path__ + "static/media/photo--lg--kickoff1.d1e23390.jpg";